<div class="row ">
  <div class="col-12">
    <app-icon-with-input [inputName]="'customerAddress1'" 
      [inputType]="'text'" [inputId]="'customerAddress1'"
      (keydown.enter)="onKeydown($event, 'customerAddress2')"
      [inputValue]="customerDetails?.shippingAddressModel?.addressLine1"
      (inputValueEmit)="customerDetails.shippingAddressModel.addressLine1 = $event"
      [inputPlaceholder]="'Address 1'" [InputLabel]="'Address 1'" labelName="true" [className]="'w-90px'"></app-icon-with-input>
  </div>
</div>

<div class="row mt-2 ">
  <div class="col-12">
    <app-icon-with-input [inputName]="'customerAddress2'"
      [inputType]="'text'" [inputId]="'customerAddress2'" 
      (keydown.enter)="onKeydown($event, 'shippingAddressCountry')"
      [inputValue]="customerDetails?.shippingAddressModel?.addressLine2"
      (inputValueEmit)="customerDetails.shippingAddressModel.addressLine2 = $event" [inputPlaceholder]="'Address 2'"
      [InputLabel]="'Address 2'" labelName="true" [className]="'w-90px'"></app-icon-with-input>
  </div>
</div>

<div class="row mt-2">
  <div class="col-12 d-flex">
    <div class="col-6 d-flex pe-1 country_dropdown_container">  
      <div class="d-flex align-items-center country_dropdown">
        <label class="text-nowrap mb-0">Country</label>
      </div>
      <div class="col ml-85">
        <app-custom-select2 
          #countryShippingDropdown
          [formModel]=""
          [customId]="'countryShippingDropdown'"
          [whichDropdown]="storageName?.COUNTRY_DROPDOWN"
          (valueChanged)="assignShippingAddressCountryId($event)" 
          (keydown.enter)="onKeydown($event, 'shippingAddressState')"
        >
        </app-custom-select2>
      </div>
    </div>
    <div class="col-6 d-flex ps-1 country_dropdown_container">  
      <div class="d-flex align-items-center country_dropdown">
        <label class="text-nowrap mb-0">State</label>
      </div>
      <div class="col ml-85">
        <app-custom-select2 
          #stateShippingSelect
          [formModel]=""  
          [customId]="'stateShippingSelect'"
          [whichDropdown]="storageName?.STATE_DROPDOWN"
          (valueChanged)="assignShippingAddressStateId($event)" 
          (keydown.enter)="onKeydown($event, 'customerPinCode')"
        >
        </app-custom-select2>
      </div>
    </div>
  </div>
</div>

<div class="row mt-2">
  <div class="col-6 pe-1">
    <app-icon-with-input [inputName]="'customerPinCode'" [inputMaxlength]="9" [isOnlyAlphabetsAndNumbers]="true"
      [inputType]="'text'" [inputId]="'customerPinCode'"
      [inputValue]="customerDetails?.shippingAddressModel?.pinCode"
      [isAllowDecimal]="false"
      (keydown.enter)="onKeydown($event, 'billingAddressActive')"
      (inputValueEmit)="customerDetails.shippingAddressModel.pinCode = $event" [isRequired]="false"
      [inputPlaceholder]="'Zip Code'" [InputLabel]="'Zip Code'" labelName="true" [className]="'w-90px'"></app-icon-with-input>
  </div>
  <div class="col d-flex"> 
      <div class="col d-flex align-items-center">
          <app-checkbox 
          [dyanamicId]="'billingAddressActive'" 
          [isRequired]="false" 
          [status]="customerDetails.shippingAddressModel.active" 
          (check)="checkShipping($event)"
          [lableName]="'Same As Billing Address'"
          ></app-checkbox>
      </div>
  </div>
</div>

